import {PackageNewDataItem} from './data-item.model';

export class ListDataPackageNewResponse {
 
    data: Array<PackageNewDataItem> = [];

    constructor(obj = null) {
        obj = obj || {};

        this.data = [];
        if (obj.data && obj.data instanceof Array) {
            obj.data.forEach((item) => {
                this.data.push(new PackageNewDataItem(item));
            })
        }
    }
}
